export default __webpack_public_path__ + "static/media/logo.bbc1bef0.png";